import React, { useEffect } from "react";
import Header from "../components/Header.js";
import LoginSideMenu from "../components/LoginSideMenu.js";
import { useMenu } from "../hooks/index.js";

const WelcomePage = () => {
  const { setMenuOpen } = useMenu();

  useEffect(() => {
    setMenuOpen(true);
  }, [setMenuOpen]);

  return (
    <div className="App">
      <Header loggedIn={false} />
      <LoginSideMenu />
      <div style={{ textAlign: "center", padding: "50px" }}>
        <img
          src="/media/PriorityPop_logo.png"
          alt="PriorityPop Logo"
          style={{ maxWidth: "200px", marginBottom: "20px" }}
        />
        <h1>Thanks for subscribing!</h1>
        <p>
          Welcome to PriorityPop! If you already have an account, please log in
          now using the menu button in the top right.
        </p>
        <p>
          If you are newly subscribed please check your email confirmation for
          instructions to set your initial password.
        </p>
      </div>
    </div>
  );
};

export default WelcomePage;
